var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomContactDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 9H17V12H11V9H6.5C5.67187 9 5 9.67188 5 10.5V21.5C5 22.3281 5.67187 23 6.5 23H21.5C22.3281 23 23 22.3281 23 21.5V10.5C23 9.67188 22.3281 9 21.5 9ZM14 14C15.1031 14 16 14.8969 16 16C16 17.1031 15.1031 18 14 18C12.8969 18 12 17.1031 12 16C12 14.8969 12.8969 14 14 14ZM16.9156 21H11.0844C10.7594 21 10.4969 20.6875 10.5969 20.3813C10.8563 19.5813 11.6094 19 12.5 19H12.7563C13.1406 19.1594 13.5594 19.25 14 19.25C14.4406 19.25 14.8625 19.1594 15.2437 19H15.5C16.3875 19 17.1406 19.5781 17.4031 20.3813C17.5031 20.6875 17.2406 21 16.9156 21ZM16 8C16 7.44687 15.5531 7 15 7H13C12.4469 7 12 7.44687 12 8V11H16V8Z",
    fill: "#727272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5L0 0H10L5 5Z",
    fill: "#727272"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomContactDown);
export default __webpack_public_path__ + "static/media/CustomContactDown.f853db577c72f65f5526bb68b96610ef.svg";
export { ForwardRef as ReactComponent };